module.exports = __webpack_public_path__ + "img/ic／4.645d8056.png";